import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { PlanDetails } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const planApi = {
	getPlan: (workspaceId: string): Promise<AxiosResult<PlanDetails>> => {
		return axiosRequest({ url: `${API_BASE_URL}/${workspaceId}/plan`, method: "GET" });
	},
};